import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import OctagonBadge from '../../components/OctagonBadge/OctagonBadge'
import Close from '!!@svgr/webpack!media/close.svg'

export default function DiscountInfo({
  signup = false,
  discountPercentage = 30,
  trialLength = 7,
  subscriptionLength = 12,
}) {
  const [showDiscountInfo, setShowDiscountInfo] = useState(true)
  if (!showDiscountInfo) return null
  return (
    <div className="bg-white py-12 px-20 shadow-elevated sticky top-0 z-20">
      <div className="max-w-1280 mx-auto flex justify-start">
        <OctagonBadge small>
          <span>-{discountPercentage}%</span>
        </OctagonBadge>
        <p className="type-small my-auto ml-16">
          <span className="block type-14-demibold-caps mb-4">
            <FormattedMessage
              id="trial_ad_discount_heading"
              defaultMessage="Exclusive deal!"
            />
          </span>
          {signup ? (
            <FormattedMessage
              id="trial_ad_discount_text2"
              defaultMessage="Continue to claim your free {trialLength}-day trial and {discountPercentage}% discount."
              values={{
                trialLength: trialLength,
                discountPercentage: discountPercentage,
              }}
            />
          ) : (
            <FormattedMessage
              id="trial_ad_discount_text"
              defaultMessage="Try {trialLength} days for free, PLUS get {discountPercentage}% off a {subscriptionLength}-month subscription when purchasing via this page."
              values={{
                trialLength: trialLength,
                discountPercentage: discountPercentage,
                subscriptionLength: subscriptionLength,
              }}
            />
          )}
        </p>
        <button
          className="cursor-pointer my-auto ml-auto"
          onClick={() => setShowDiscountInfo(false)}
        >
          <Close />
          <span className="sr-only">Hide discount info</span>
        </button>
      </div>
    </div>
  )
}

DiscountInfo.propTypes = {
  signup: PropTypes.bool,
  discountPercentage: PropTypes.bool,
  trialLength: PropTypes.bool,
  subscriptionLength: PropTypes.bool,
}
